function forceTrailingSlash(link) {
  if (typeof link === 'string' && link.length > 1) {
    if (link.includes('?')) {
      const linkParts = link.split('?');
      linkParts[0] = linkParts[0].replace(/\/$|$/, `/`);
      return linkParts.join('?');
    }

    return link === `/` ? link : link.replace(/\/$|$/, `/`);
  }

  return link;
}

function shouldAddTrailingSlash(link) {
  return (
    typeof link === 'string' &&
    link.length > 1 &&
    !link.startsWith('http') &&
    link !== '/'
  );
}

module.exports = {
  forceTrailingSlash,
  shouldAddTrailingSlash,
};
